<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddPromotions</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>
      <form [formGroup]="addPromotionsForm" (ngSubmit)="addPromotions()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6 af-form-group">
                  <label for="typeahead-format" translate>lblSelectDealer
                    <span class="text-danger"> * </span>
                     </label>
                  <div class='lbl-info'>
                    <ng-multiselect-dropdown style="width: 25%;" formControlName="dealer" [settings]="dropdownSettings" [data]="dealerList" placeholder="{{ 'lblSearchDealer'| translate}}" [(ngModel)]="dealerSelected">
                    </ng-multiselect-dropdown>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="af-form-group">
                    <label for="service" translate>lblCategory
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <div class="form-group">
                        <ng-select class="" formControlName="category"
                          [ngClass]="{'is-invalid': cpf.category.invalid && cpf.category.touched}"
                          placeholder="{{ 'lblSelectCategory' | translate }}">
                          <option disabled [ngValue]="null" translate>lblCategoryRequired</option>
                          <ng-template ng-header-tmp>
                            <span class="mbold w-66px">Code</span>
                            <span class="mbold" translate>lblCategory</span>
                          </ng-template>

                          <ng-option *ngFor="let category of categoryList" [value]="category.id">
                            <span class="w-66px">{{category.id}}</span>
                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                            <span>{{category.name}}</span>
                          </ng-option>
                        </ng-select>

                        <div *ngIf="cpf.category.invalid && (cpf.category.dirty || cpf.category.touched)"
                          class="help-block text-danger">
                          <div *ngIf="cpf.category.errors.required"><span translate>lblCategoryRequired</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 px-0" *ngIf="p.controls">
                  <div class="col-md-6" *ngFor="let ticket of p.controls; let i = index">
                    <div [formGroup]="ticket" class="">
                      <div class="af-form-group">
                        <label for="description" translate>lblPromotionName<span> in
                            {{allLanguage[i].value}}</span> </label>
                        <div class='lbl-info'>
                          <input formControlName="name" class="form-control mb-2" required maxlength="50"
                            >
                          
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>lblLanguageId</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 px-0" *ngIf="t.controls">
                  <div class="col-md-6" *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket" class="">
                      <div class="af-form-group">
                        <label for="description" translate>lblPromotionDescription<span> in
                            {{allLanguage[i].value}}</span> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" required maxlength="200"
                            >
                          
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>lblLanguageId</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="startDate" translate>lblStartDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'2011/01/01'"
                      required [dateTime]="false" placeholder="{{ 'lblEnterStartDate' | translate }}"
                      [disableNextMonthDates]="true" formControlName="startDate" [(ngModel)]="startDate"
                      id="txtboxStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="endDate" translate>lblEndDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker" appAfDatepicker [startDate]="'2011/01/01'"
                      placeholder="{{ 'lblEnterEndDate' | translate }}" required [dateTime]="false"
                      [disableNextMonthDates]="true" formControlName="endDate" [(ngModel)]="endDate"
                      id="txtboxStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="service" translate>lblOriginalPrice
                    <strong class="mlt6 required"> * </strong> </label>
                  <div class='lbl-info'>
                    <input formControlName="originalPrice" class="form-control mb-2" maxlength="50">
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="startDate" translate>lblOfferStartDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'2011/01/01'"
                       [dateTime]="false" placeholder="{{ 'lblEnterStartDate' | translate }}"
                      [disableNextMonthDates]="true" formControlName="offerStartDate" [(ngModel)]="offerStartDate"
                      id="txtboxOfferStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="endDate" translate>lblOfferEndDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker" appAfDatepicker [startDate]="'2011/01/01'"
                      placeholder="{{ 'lblEnterEndDate' | translate }}"  [dateTime]="false"
                      [disableNextMonthDates]="true" formControlName="offerEndDate" [(ngModel)]="offerEndDate"
                      id="txtboxOfferEndDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="service" translate>lblOfferPrice
                     </label>
                  <div class='lbl-info'>
                    <input formControlName="offerPrice" class="form-control mb-2" maxlength="50">
                  </div>
                </div>

                <div class="col-md-12 af-form-group">
                  <label for="template-edit-image" translate>lblImage </label>
                  <div class="lbl-info">
                    <div class="custom-file">
                      <label class="btn btn-outline-primary d-inline-block" for="select-files"
                        translate>lblUploadImage</label>
                      <input type="file" id="select-files" class="" hidden formControlName="image"
                        accept=".png, .jpg, .jpeg" (change)="onChangeFileUpload($event.target.files)">
                    </div>
                    <ng-container *ngIf="promotion.image">
                      <div *ngIf="promotion.image" class="border mt-3 p-1 d-inline-block">
                        <img height="50" [src]="promotion.promotionImage" id="UploadImage" alt="image does not found."
                          onError="this.onerror=null; this.src='../../../../../assets/images/no-image-icon.png'"
                          class="carimg">
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="col-md-6 af-form-group">
                  <label for="template-edit-image" translate>&nbsp; </label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" 
             translate><em
                class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em
                class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>